'use client';

import Button from '@/components/core/Button/Button';
import Typography from '@/components/core/Typography/Typography';
import Image from 'next/image';
import { ReactNode } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    justify-self: center;
    align-self: center;
    background-color: ${({ theme }) => theme.colors.palette.white};
    width: 1368px;
    height: calc(100% - 36px);
    min-height: 600px;
    margin-top: 18px;
    border-radius: 12px;
    gap: ${({ theme }) => theme.spacing['2xl']};
    color: ${({ theme }) => theme.colors.palette.grey_800};
`;

const Header = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    justify-self: center;
    align-self: center;
    gap: ${({ theme }) => theme.spacing['2xs']};
`;

const Bottom = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    justify-self: center;
    align-self: center;
    gap: ${({ theme }) => theme.spacing['2xs']};
`;

const Buttons = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    justify-self: center;
    align-self: center;
    gap: ${({ theme }) => theme.spacing['2xs']};
`;

const StyledButton = styled(Button)`
    padding: 13.5px ${({ theme }) => theme.spacing['2xs']};
    height: 48px;
`;

interface ErrorPageLayoutProps {
    title: string;
    subtitle: string;
    description: string;
    imageSrc: string;
    imageWidth?: number;
    imageHeight?: number;
    actions: ReactNode;
}

export default function ErrorPageLayout({
    title,
    subtitle,
    description,
    imageSrc,
    imageWidth = 300,
    imageHeight = 300,
    actions
}: ErrorPageLayoutProps) {
    return (
        <Wrapper>
            <Header>
                <Typography size='3xl' variant='uiType' modifier='S'>
                    {title}
                </Typography>
                <Typography size='xl' variant='uiType' modifier='R'>
                    {subtitle}
                </Typography>
                <Image src={imageSrc} alt='error' width={imageWidth} height={imageHeight} />
            </Header>
            <Bottom>
                <Typography size='sm' variant='uiType' modifier='R'>
                    {description}
                </Typography>
                <Buttons>{actions}</Buttons>
            </Bottom>
        </Wrapper>
    );
}

ErrorPageLayout.Button = StyledButton;
